import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from 'context/authContext';
import { StyledToastContainer } from 'styles/App.styles';
import GlobalStyles from 'styles/GlobalStyles.styles';
import { LoadingContextProvider } from 'context/loadingContext';
import { SideNavContextProvider } from 'context/sideNavContext';
import { FiltersContextProvider } from 'context/filtersContext';
import { MQTTContextProvider } from 'context/mqttContext';
import ErrorBoundary from './components/organisms/ErrorBoundary';
import Router from './Router';
import 'react-toastify/dist/ReactToastify.min.css';
import './utils/globalErrorHandler';
import './utils/errorDebugUtils';

function App() {
  return (
    <ErrorBoundary>
      <LoadingContextProvider>
        <SideNavContextProvider>
          <FiltersContextProvider>
            <GlobalStyles />
            <BrowserRouter>
              <AuthContextProvider>
                <MQTTContextProvider>
                  <Router />
                </MQTTContextProvider>
              </AuthContextProvider>
            </BrowserRouter>
            <StyledToastContainer />
          </FiltersContextProvider>
        </SideNavContextProvider>
      </LoadingContextProvider>
    </ErrorBoundary>
  );
}

export default App;
